import css from 'styled-jsx/css';

export const styles = css`
    .FooterCertificate {
      width: 80px;
      height:  80px;
    }
  `;
